import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const reviews: Review[] = [{
  initials: 'MF',
  quote: 'I opened Volume 3 on a Sunday afternoon and by Monday I had completely restructured how I explain chakras to my clients. The visual correspondence charts and rebalancing protocols are unlike anything I had seen in years of studying. Completely changed my sessions.',
  name: 'Michelle F.',
  role: 'Sydney, Australia · Chakra Practitioner'
}, {
  initials: 'NG',
  quote: 'The Sacred Geometry bonus was the piece I had been missing for two years. Having every symbol explained with its spiritual meaning and energy application in one visual library saved me countless hours of research. I refer to it every single week.',
  name: 'Nicole G.',
  role: 'Toronto, Canada · Energy Healer'
}, {
  initials: 'AL',
  quote: 'I used the Pendulum Decoded chart sets with a new client last week. For the first time I felt completely confident and professional. My client was amazed at the depth and structure of the session. This system is the real foundation my practice was missing.',
  name: 'Amanda L.',
  role: 'Manchester, UK · Holistic Coach'
}];
export function Reviews() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-199" data-mp="2hgkgvqwp3rrf">
      <div className="mx-auto max-w-6xl" data-id="element-200" data-mp="2de7kvu7r387u">
        <Reveal className="text-center" data-id="element-201" data-mp="2df8ya5c8o6sq">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-202" data-mp="3a3ez0h61if1q">
            ⭐ More Real Results from <span className="text-sage" data-id="element-203" data-mp="353sk83akcqqt">Real Practitioners</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-204" data-mp="30d3tiq6pjxsq">
            4.9/5 · Hundreds already building their professional practice.
          </p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-205" data-mp="2wb8rfjgydgdw">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} data-id="element-206" data-mp="3sug3fkpxj2so" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-7 shadow-premium" data-id="element-207" data-mp="3o2ekjfy9adto">
                <div className="text-amber" data-id="element-208" data-mp="1m6ffp0jqgxv4">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-209" data-mp="1m7qmzace0nqz">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-210" data-mp="1cejevhq9itn7">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-211" data-mp="1he5ufxtkclz6">
                    {review.initials}
                  </span>
                  <span data-id="element-212" data-mp="18dpwf3vla71p">
                    <span className="block font-bold text-navy" data-id="element-213" data-mp="18f0viqe3aqmh">{review.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-214" data-mp="th8mmh31t0h9">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}